import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol viewBox=\"0 0 13 13\" id=\"icon-search\"><path d=\"M8.31 6.896l3.397 3.397a1 1 0 01-1.414 1.414L6.896 8.31A4.5 4.5 0 118.31 6.896zM4.5 7a2.5 2.5 0 100-5 2.5 2.5 0 000 5z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol